<template>
  <div class="file-cell round-border">
    <template v-if="isPlaceholder">
      <div class="file-image placeholder"/>
      <div class="button-container placeholder"/>
    </template>
    <template v-else>
      <gx-tooltip
        theme="light"
        class="tooltip">
        <div class="tooltip-content">
          <p>File Type: <span style="font-weight: 700;">{{ fileType }}</span></p>
          <p>Link: <span style="font-weight: 700;">{{ imageLink }}</span></p>
          <p>Created Date: <span style="font-weight: 700;">{{ file.created_date }}</span></p>
        </div>
      </gx-tooltip>
      <img
        ref="fileImage"
        :src="image"
        class="file-image fade-in-on-load">
      <div class="button-container">
        <el-tooltip
          :content="copyText"
          effect="dark"
          placement="bottom">
          <el-button
            v-clipboard:copy="imageLink"
            v-clipboard:success="imageLinkCopied"
            :icon="copyIcon"
            type="primary"
            size="mini"
            circle/>
        </el-tooltip>
        <el-button
          :disabled="!isImageFile"
          size="mini"
          icon="el-icon-search"
          circle
          @click="showEnlargeImagePopup = true"/>
        <el-popover
          v-model="showDeletePopup"
          placement="top"
          width="180">
          <p>Are you sure you want to delete this?</p>
          <div style="display: flex; justify-content: space-around;">
            <el-button
              type="text"
              size="mini"
              @click="showDeletePopup = false">Cancel</el-button>
            <el-button
              type="danger"
              size="mini"
              @click="removeFile">Confirm</el-button>
          </div>
          <el-button
            slot="reference"
            style="margin-left: 10px;"
            type="danger"
            size="mini"
            disabled
            icon="el-icon-delete"
            circle/>
        </el-popover>
      </div>
      <el-dialog
        :visible.sync="showEnlargeImagePopup"
        width="80%"
        top="10vh">
        <img
          :src="imageLink"
          width="100%"
          alt="Enlarged Image">
      </el-dialog>
    </template>
  </div>
</template>

<script>
import { checkImageURL } from '../../../utils/validate'
import clipboard from '../../../directive/clipboard/index'

export default {
  name: 'FileListCell',
  directives: {
    clipboard,
  },
  props: {
    file: {
      type: Object,
      default: () => {},
    },
    isPlaceholder: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showDeletePopup: false,
      showEnlargeImagePopup: false,
      isCopied: false,
    }
  },
  computed: {
    image() {
      if (!this.isImageFile) {
        return 'https://cdn.goxip.com/goxip_res/goxip_if-10-folder-290140.png'
      }
      return this.imageLink
    },
    imageLink() {
      return this.file ? this.file.img_url : ''
    },
    isImageFile() {
      return checkImageURL(this.imageLink)
    },
    fileType() {
      return this.isImageFile ? 'Image' : 'File'
    },
    copyIcon() {
      return this.isCopied ? 'el-icon-check' : 'el-icon-tickets'
    },
    copyText() {
      return this.isCopied ? 'Copied' : 'Copy Link'
    },
  },
  methods: {
    removeFile() {
      this.showDeletePopup = false
      this.$emit('deleteFile', this.file)
    },
    imageLinkCopied() {
      this.isCopied = true
      setTimeout(() => {
        this.isCopied = false
      }, 1500)
    },
  },
}
</script>

<style lang="scss" scoped>
  .file-cell {
    display: flex;
    justify-content: center;
    flex-flow: column;
    position: relative;
    width: calc(100% / 2 - 20px);
    margin: 8px;
    padding: 10px;
    transition: all 0.5s;
    height: 200px;
    @include tablet {
      width: calc(100% / 4 - 30px);
    }
    @include desktop {
      width: calc(100% / 6 - 20px);
    }
    .tooltip {
      position: absolute;
      top: 5px;
      right: 5px;
    }
    .file-image {
      max-width: 160px;
      max-height: 150px;
      height: 100%;
      width: 100%;
      object-fit: contain;
      margin: auto;
      margin-bottom: 5px;
    }
    .fade-in-on-load {
      animation-duration: 1.5s;
      animation-name: fadeInOnLoad;
    }
    @keyframes fadeInOnLoad {
      0%,50% {opacity: 0;}
      100% {opacity: 1;}
    }
    .button-container {
      display: flex;
      justify-content: space-around;
      align-items: center;
      margin: 5px auto;
      min-height: 20px;
      width: 100%;
    }
  }
</style>
